import { LabelProps } from "recharts";

export const filterAxisProps = (props: LabelProps): Omit<LabelProps, "viewBox" | "text" | "textBreakAll" | "parentViewBox" | "content"> => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { viewBox, textBreakAll, parentViewBox, content, ...rest } = { ...props };

	return rest;
};
